import React from 'react';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/**
 * An Icon that opens the activity feed for the selected cell
 *
 */
export default React.createClass({
  displayName: 'CellHistoryIcon',

  render() {
    return (
      <Icon
        title="Show the cell history"
        onClick={() => this._handleHistoryClick()}
        name="list"
        className="cs-data-cell-history-icon"
      />
    );
  },

  _handleHistoryClick() {
    if (this.props.onClick) {
      this.props.onClick();
    } else {
      CuesheetCellActions.showSelectedCellHistory();
    }
  },
});
